<template>
    <div>
        <transition name="animation" appear mode="out-in">
            <p key="1" v-if="showLeft">{{ hint1 }}</p>
            <p key="2" v-else>{{ hint2 }}</p>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'LoadingHint',
    props: {
        timer: {
            type: Number,
            default: 3000,
        },
        hints: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            interval: null,
            counter: 0,
        };
    },
    computed: {
        showLeft() {
            return this.counter % 2 === 0;
        },
        hint1() {
            return this.hints[this.counterToIndex()];
        },
        hint2() {
            return this.hints[this.counterToIndex()];
        },
    },
    methods: {
        counterToIndex() {
            return this.counter % this.hints.length;
        },
        increment() {
            this.counter++;
        },
        startInterval() {
            this.interval = setInterval(this.increment, this.timer);
        },
        stopInterval() {
            clearInterval(this.interval);
            this.interval = null;
        },
    },
    mounted() {
        this.startInterval();
    },
    beforeDestroy() {
        if (this.interval) {
            this.stopInterval();
        }
    },
};
</script>

<style scoped>
.animation-enter-active,
.animation-leave-active {
    transition: opacity 1s ease, transform 0.5s ease;
    opacity: 1;
    transform: translateX(0);
}
.animation-enter,
.animation-leave-to {
    transition: all 0.5s ease;
    opacity: 0;
}
.animation-enter {
    transform: translateX(50px);
}
.animation-leave-to {
    transform: translateX(-50px);
}
</style>
